import BookIcon from '@material-ui/icons/Book'
import QuestionShow from './QuestionShow'
import QuestionList from './QuestionList'

export default {
  list: QuestionList,
  show: QuestionShow,
  icon: BookIcon,
}
